import { useContext } from "react";
import OrderContext from "../../contexts/OrderContext/OrderContext";

export default function useOrderPriceTotal() {
  const { state: {  localPrices,  } } = useContext(OrderContext);
  const { itemPrice: { final }, currencySymbol } = localPrices;

  if (!currencySymbol || final === undefined) return "undefined";
  return `${currencySymbol}${final.toFixed(2)}`;
}